import * as React from "react";
import Avatar from "@mui/material/Avatar";

function intToColor(x) {
  let A;
  if (typeof Uint32Array === undefined) {
    A = [0];
  } else {
    A = new Uint32Array(1);
  }
  A[0] = x | 0;
  A[0] -= A[0] << 6;
  A[0] ^= A[0] >>> 17;
  A[0] -= A[0] << 9;
  A[0] ^= A[0] << 4;
  A[0] -= A[0] << 3;
  A[0] ^= A[0] << 10;
  A[0] ^= A[0] >>> 15;
  const hash = A[0];
  let color = "#";

  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}

function expandProps({name, id, ...otherProps}) {
  name = name || "";
  id = id || 0;
  const names = name.split(" ");
  return {
    ...otherProps,
    sx: {
      ...otherProps.sx,
      bgcolor: intToColor(id),
    },
    children:
        names.length > 1
            ? `${names[0]?.[0]}${names[1]?.[0]}`
            : `${names[0]?.[0]}`,
  };
}

export const BackgroundLetterAvatar = (props) => (
    <Avatar {...expandProps(props)} />
);
